import React from "react";
import { toast } from "react-toastify";

const CashModal = ({
    show,
    onClose,
    input,
    setInput,
    getAmountDue,
    getReturnValue,
    getReminingValue,
    handleClick,
    handleBackspace,
    CustomerId,
    handleSubmit,
    paidAmount,
    isSales,
    loading = false
}) => {
    const amountDue = parseFloat(getAmountDue());
    const returnValue = getReturnValue();
    const remainingValue = getReminingValue();
    const isDisabled = amountDue < 0;

    const handleInputChange = (e) => {
        let value = e.target.value;
        if (/^\d*\.?\d*$/.test(value)) { // Allow only numbers & decimals
            if (setInput) {
                setInput(value);
            } else {
                // Fallback simulation if parent doesn't pass setInput
                if (value.length < input.length) {
                    handleBackspace();
                } else if (value.length > input.length) {
                    const diff = value.substring(input.length);
                    for (let char of diff) {
                        handleClick(char);
                    }
                }
            }
        }
    };

    return (
        <div
            className={`modal fade ${show ? "show" : ""}`}
            style={{ display: show ? "block" : "none" }}
            tabIndex="-1"
            role="dialog"
        >
            <div className="modal-dialog">
                <div className="modal-content p-3">

                    {/* Modal Header */}
                    <div className="modal-header border-0">
                        <h5 className="modal-title fw-bold text-dark font-18">Payment</h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
                    </div>

                    {/* Modal Body */}
                    <div className="modal-body">
                        <div className="row">

                            {/* Number Pad Section - Commented out per request */}
                            {/* 
                            <div className="col-6">
                                <div className="phone-pad-container">
                                    <input
                                        type="text"
                                        value={input}
                                        readOnly
                                        className="phone-input"
                                        disabled={isDisabled}
                                    />
                                    <div className="grid-container">
                                        {["1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "0", "⌫"].map((key, index) => (
                                            <button
                                                key={index}
                                                className="key-btn"
                                                onClick={() => {
                                                    if (amountDue > 0) {
                                                        key === "⌫" ? handleBackspace() : handleClick(key);
                                                    }
                                                }}
                                            >
                                                {key}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            */}

                            {/* Payment Summary Section - Expanded to col-12 */}
                            <div className="col-12">
                                {paidAmount && <div>
                                    <label className="text-sm font-semibold text-gray-700 w-100">Paid Amount
                                    </label>
                                    <input
                                        type="text"
                                        value={paidAmount}
                                        disabled
                                        className={`w-100 p-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none
                                                `}
                                    //  ${label == "Credit" ? 'bg-warning-subtle' : ''}
                                    />

                                </div>}
                                {[
                                    { label: "Total", value: amountDue },
                                    { label: "Cash", value: input },
                                    { label: "Return", value: returnValue },
                                    { label: "Credit", value: remainingValue },
                                ].map(({ label, value }, index) => (
                                    <div key={index} className="mb-2">
                                        <label className="text-sm font-semibold text-gray-700 w-100">{label}</label>
                                        <input
                                            type="text"
                                            value={value}
                                            disabled={label !== "Cash"}
                                            onChange={label === "Cash" ? handleInputChange : undefined}
                                            className={`w-100 p-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none ${label == "Credit" ? 'bg-warning-subtle' : ''}`}
                                        />
                                    </div>
                                ))}

                                {/* Pay Button */}
                                <button
                                    onClick={() => {
                                        if (loading) return;
                                        if (getReminingValue() > 0 && isSales) {
                                            console.log(getReminingValue())
                                            if (CustomerId) {
                                                handleSubmit(1)
                                            } else {
                                                toast.error("Customer details are required for credit sales.")
                                            }
                                        } else {
                                            handleSubmit(1)
                                        }
                                    }}
                                    disabled={loading || !input}
                                    style={{ pointerEvents: loading ? 'none' : 'auto' }}
                                    className="w-full mt-2 btn btn-success text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-blue-700 transition d-flex align-items-center justify-content-center gap-2"
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Processing...
                                        </>
                                    ) : (
                                        "Pay"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CashModal;